export const mutations = {
  addFuelItems(state) {
    state.fuel_item.push({
      fill_date: "",
      truck_id: "",
      description: "",
      litre: "",
      rate_per_litre: "",
      total_price: "",
      date_loading: "",
      consignee_id: "",
      station_id: "",
    });
  },

  STORE_FUELS(state, fuels) {
    state.fuels = fuels;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/fuels/mutations.js